import React from "react";
import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Boton from "../boton/Boton";
import Error from "../generales/Error";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import Colors from "./Colors";
import Spinner from "components/generales/Spinner";
//import { registerLabelAPI } from 'api/etiquetas';

///////////////////////////////////////

////////////////////////////////////////

const RegistroEtiquetas = ({
  etiqueta,
  cargando,
  //registroEtiquetas,
  //setRegistroEtiquetas,
}) => {
  const [error, setError] = useState(false);
  //const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const nuevaEtiquetaSchema = Yup.object().shape({
    descripcion: Yup.string().required("Este campo es obligatorio"),
    tipo: Yup.string().required("Este campo es obligatorio"),
    clasificacion: Yup.string().required("Este campo es obligatorio"),
    color: Yup.string(),
  });
  // console.log(etiqueta.id, etiqueta.usuario_id);
  const handleSubmit = async (valorEtiqueta) => {
    try {
      if (etiqueta.id) {
        //editando etiqueta
        // console.log("editando");
        const url = `https://mymoney5.herokuapp.com/etiquetas/${etiqueta.id}`;
        const id = localStorage.getItem("id")
        if (
          !id
        ) {
          navigate("/", {
            replace: true
          })
        }
        const body = JSON.stringify({
          id: valorEtiqueta.id,
          descripcion: valorEtiqueta.descripcion,
          tipo: valorEtiqueta.tipo,
          clasificacion: valorEtiqueta.clasificacion,
          color: valorEtiqueta.color,
          status: true,
        });
        const params = {
          headers: {
            "Content-Type": "application/json",
          },
        };
        const { status, data } = await axios.put(url, body, params);
        // console.log(status, data);
        if (status === 200) {
          // console.log("Etiqueta editada");
        }
        navigate("/etiquetas");
      } else {
        //nuevo registro
        // console.log("nueva etiqueta");
        const url = "https://mymoney5.herokuapp.com/etiquetas";
        const { status, data } = await axios.post(url, valorEtiqueta);
        // console.log(status, data);
        if (status === 200) {
          // console.log("Etiqueta registrada");
        }
        navigate("/etiquetas");
      }
    } catch (error) {
      console.log(error);
      setError(true);
      return;
    }
    setError(false);
  };

  return cargando ? (
    <Spinner />
  ) : (
    <Formik
      initialValues={{
        id: etiqueta?.id ?? "",
        descripcion: etiqueta?.descripcion ?? "",
        tipo: etiqueta?.tipo ?? "",
        clasificacion: etiqueta?.clasificacion ?? "",
        color: etiqueta?.color ?? "#AD1457",
        status: true,
      }}
      enableReinitialize={true}
      onSubmit={async (values, { resetForm }) => {
        await handleSubmit(values);

        resetForm();
      }}
      validationSchema={nuevaEtiquetaSchema}
    >
      {({ errors, touched, values }) => {
        return (
          <Form>
            <div className="formulario-input">
              <label htmlFor="descripcion">Descripción</label>
              <Field
                id="descripcion"
                type="textarea"
                placeholder="Descripción de la etiqueta"
                name="descripcion"
              />
              {errors.descripcion && touched.descripcion ? (
                <Error>{errors.descripcion}</Error>
              ) : null}
            </div>
            <div className="formulario-input">
              <label htmlFor="tipo">Tipo</label>
              <Field id="tipo" component="select" name="tipo">
                <option value="">--Selecciona una opción--</option>
                <option value="gasto">Gasto</option>
                <option value="ingreso">Ingreso</option>
              </Field>
              {errors.tipo && touched.tipo ? (
                <Error>{errors.tipo}</Error>
              ) : null}
            </div>
            <div className="formulario-input">
              <label htmlFor="clasificacion">Clasificación</label>
              <Field id="clasificacion" component="select" name="clasificacion">
                <option value="">--Selecciona una opción--</option>
                <option value="Fijo">Fijo</option>
                <option value="Variable">Variable</option>
              </Field>
              {errors.clasificacion && touched.clasificacion ? (
                <Error>{errors.clasificacion}</Error>
              ) : null}
            </div>

            <div className="formulario-input">
              <label htmlFor="color">Color</label>
              <Field id="color" component={Colors} name="color">
                <Colors />
                {errors.color && touched.color ? (
                  <Error>{errors.color}</Error>
                ) : null}
              </Field>
            </div>
            <Boton>Guardar</Boton>

            {error && (
              <div className="formulario-error">
                <p>Ocurrio un error, intenta de nuevo</p>
              </div>
            )}
          </Form>
        );
      }}
    </Formik>
  );
};

RegistroEtiquetas.defaultProps = {
  etiqueta: {},
  cargando: false,
};

export default RegistroEtiquetas;
